import React, { useEffect, useState } from "react";
import "./All_Products.css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Col, Form, Nav, Row, Spinner, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faSort } from "@fortawesome/free-solid-svg-icons";
import Product_card_2 from "../../common/common_components/product-card-2/Product_card_2";
import Sort_By_Modal from "../../common/modals/sort_by_modal/Sort_By_Modal";
import { Link, useLocation } from "react-router-dom";
import Common_Back_Header from "../../common/common_components/common_back_header/Common_Back_Header";
import { GetAllProducts } from "../../../features/admin/products/slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";
import { AllCategory } from "../../../features/admin/common/Slice";
import { encodeId } from "../../../utils/common";

const All_Products = () => {
  const location = useLocation(); // ✅ Get current path
  const category = [
    "All Items",
    "Rudraksh",
    "Puja Items",
    "Vastu Items",
    "Yantra",
    "Jap Maala",
    "Rudraksh",
    "Puja Items",
    "Vastu Items",
    "Yantra",
    "Jap Maala",
  ];
  const [activeCategory, setActiveCategory] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [sortBy, setSortBy] = useState(false);
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const dispatch = useDispatch();
  const products = useSelector((state) => state.commerce.products);
  const categories = useSelector((state) => state.common.all_category);

  useEffect(() => { dispatch(AllCategory()); }, [])

  useEffect(() => {

    let params = {};
    if (activeCategory !== "all") {
      params.p_category_id = activeCategory;
    }
    if (sortBy !== "default") {
      params.sortBy = sortBy;
    }
    if (searchValue) {
      params.name = searchValue;
    }

    dispatch(GetAllProducts(params));

  }, [dispatch, activeCategory, sortBy, showSearchBox]);




  return (
    <section className="All_Products">
      <div className="container-lg">

        <Common_Back_Header backNavigation={-1} />

    <Common_Title_1 subText={"All Products"} />

        <div className="search_div">
          <div className="search_box">
            <Form.Control
              type="text"
              placeholder="Search Product..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              autoFocus
            />
            <div className="icon_holder"
              onClick={() => setShowSearchBox(!showSearchBox)}
            >
              <FontAwesomeIcon icon={faMagnifyingGlass} className="inner_icon" />
            </div>
            <button
              onClick={() => { setSearchValue(""); setShowSearchBox(!showSearchBox) }}
              className="close_btn"
            >
              ✕
            </button>
          </div>

        </div>

        

        <div className="sort_by_div" onClick={() => { setShowModal(true) }}>
          <p className="inner_text" >
            <FontAwesomeIcon icon={faSort} className="icon" />
            Sort By
          </p>
        </div>

        <Tab.Container
          id="left-tabs-example"
          activeKey={activeCategory}
          defaultActiveKey="all"
        >
          <Nav variant="pills" className="flex-row">
            <div
              className="mySwiper1"

            >

              {/* ✅ All Items Tab */}
              <div className="product_slide">
                <Nav.Item>
                  <Nav.Link
                    className={activeCategory === "all" ? "active" : ""}
                    onClick={() => setActiveCategory("all")}
                    eventKey="all"
                  >
                    All Items
                  </Nav.Link>
                </Nav.Item>
              </div>

              {/* ✅ Category Tabs */}
              {categories?.map((value, index) => (
                <div className="product_slide" key={index}>
                  <Nav.Item>
                    <Nav.Link
                      className={activeCategory === value?.value ? "active" : ""}
                      onClick={() => setActiveCategory(value?.value)}
                      eventKey={value?.value}
                    >
                      {value?.label}
                    </Nav.Link>
                  </Nav.Item>
                </div>
              ))}
            </div>
          </Nav>

          <Row>
            <Col sm={12}>
              <Tab.Content>
                <Tab.Pane eventKey={activeCategory}>
                  <div className="products_holder">
                    <div className="row">
                      {products?.data?.map((data) => (
                        <div className="col-xxl-3 col-xl-4 col-lg-4 col-sm-4 col-6 mb-md-4 mb-3 px-md-2 px-1">
                          <Product_card_2
                            product={data}
                            average_rating={data.average_rating}
                            id={data.id}
                            image={IDS.IMG_URL + data.image}
                            name={data.name}
                            subname={`(${data?.p_category?.name})`}
                            oldprise={data.mrp}
                            prise={data.price}
                            link={`/product-details/${encodeId(data.id)}`}
                          />
                        </div>
                      ))}
                    </div>

                    {location.pathname !== "/all-products" && (
                      <Link to="/all-products">
                        <p className="viel_all_text">View More</p>
                      </Link>
                    )}
                  </div>
                </Tab.Pane>


              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>

      <Sort_By_Modal
        sortBy={sortBy}
        setSortBy={setSortBy}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>

  );
};

export default All_Products;
